import React from "react";
import PreviewInfos from "./PreviewInfos";
import PreviewLists from "./PreviewLists";
function PreviewLeftContainer({ contents }) {
 
  return (
    <>
      {contents.map((content) => {
        if (content.type === "info") {
          return <PreviewInfos key={content.id} info={content} />;
        } else if (content.type === "list") {
          return <PreviewLists key={content.id} list={content} />;
        }
      })}
    </>
  );
}

export default PreviewLeftContainer;
